import { FileText, Download } from 'lucide-react';

interface AttachmentPreviewProps {
  url: string;
  name: string;
}

export function AttachmentPreview({ url, name }: AttachmentPreviewProps) {
  const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(name);

  if (isImage) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className="block mt-2">
        <img
          src={url}
          alt={name}
          className="max-w-xs max-h-48 rounded-lg border border-border object-cover cursor-pointer hover:opacity-90 transition-opacity"
        />
      </a>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 mt-2 px-3 py-2 rounded-lg border border-border bg-muted/30 hover:bg-muted/50 transition-colors w-fit"
    >
      <FileText className="w-4 h-4 text-muted-foreground" />
      <span className="text-sm font-medium truncate max-w-[200px]">{name}</span>
      <Download className="w-3 h-3 text-muted-foreground" />
    </a>
  );
}
